import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [

    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/',
          name: 'dashboard',
          component: () => import('./views/Dashboard.vue'),
          meta: { 
            requiresAuth: true,
            rule: 'public'
          }
        },
        {
          path: '/dashboard-cliente',
          name: 'dashboard-clientes',
          component: () => import('./views/pages/clients/DashboardClient.vue'),
          meta: { 
            requiresAuth: true,
            rule: 'public'
          }
        },
        {
          path: '/mi-perfil',
          name: 'mi-perfil',
          component: () => import('./views/pages/clients/perfilClientes/PerfilCliente.vue'),
          meta: {
            pageTitle: 'Mi Perfil',
            requiresAuth: true,
            rule: 'public'
          }
        },
        {
          path: '/mi-asesor',
          name: 'mi-asesor',
          component: () => import('./views/pages/clients/MyAdvisor.vue'),
          meta: {
            breadcrumb: [
              { title: 'inicio', url: '/' },
              { title: 'Mi Asesor', active: true }
            ],
            pageTitle: 'Mi Asesor C&A',
            requiresAuth: true,
            rule: 'public'
          }
        },
        {
          path: '/admin/visas-y-documentos',
          name: 'admin.visas-y-documentos',
          component: () => import('./views/pages/admin/visaTypes/VisaAndDocuments.vue'),
          meta: {
            // breadcrumb: [{ title: 'inicio', url: '/' }],
            pageTitle: 'Visados - Tipos de Documento - Plantilla Pasos Visado',
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/mis-solicitudes',
          name: 'mis-solicitudes',
          component: () => import('./views/pages/clients/misSolicitudes/MisSolicitudes.vue'),
          meta: {
            breadcrumb: [
              { title: 'inicio', url: '/' },
              { title: 'Mis solicitudes', active: true }
            ],
            pageTitle: 'Mis solicitudes',
            requiresAuth: true,
            rule: 'public'
          }
        },
        {
          path: '/extranjeria',
          name: 'extranjeria',
          component: () => import('./views/pages/clients/ExtranjeriaClient.vue'),
          meta: { 
            requiresAuth: true,
            rule: 'public'
          }
        },
        {
          path: '/admin/empleados',
          name: 'admin.empleados',
          component: () => import('./views/pages/admin/gestionEmpleados/EmpleadosIndex.vue'),
          meta: {
            breadcrumb: [
              { title: 'inicio', url: '/' },
              { title: 'Usuarios', active: false },
              { title: 'Gestión de Empleados', active: true }
            ],
            pageTitle: 'Gestión de Empleados',
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/admin/agregar-empleado',
          name: 'admin.agregar-empleado',
          component: () => import('./views/pages/admin/gestionEmpleados/AddEmployee.vue'),
          meta: {
            breadcrumb: [
              { title: 'inicio', url: '/' },
              { title: 'Usuarios', active: false },
              { title: 'Gestión de Empleados', url: '/admin/empleados', active: true },
              { title: 'Agregar Empleado', active: true }
            ],
            pageTitle: 'Agregar Empleado',
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/admin/editar-empleado/:employee_id',
          name: 'admin.editar-empleado',
          component: () => import('./views/pages/admin/gestionEmpleados/EditEmployee.vue'),
          meta: {
            breadcrumb: [
              { title: 'inicio', url: '/' },
              { title: 'Usuarios', active: false },
              { title: 'Gestión de Empleados', url: '/admin/empleados', active: true },
              { title: 'Editar Empleado', active: true }
            ],
            pageTitle: 'Editar Empleado',
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/admin/clientes',
          name: 'admin.clientes',
          component: () => import('./views/pages/admin/gestionClientes/ClientesIndex.vue'),
          meta: {
            breadcrumb: [
              { title: 'inicio', url: '/' },
              { title: 'Usuarios', active: false },
              { title: 'Gestión de Clientes', active: true }
            ],
            pageTitle: 'Gestión de Clientes',
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/admin/clientes-extranjeria',
          name: 'admin.clientes-extranjeria',
          component: () => import('./views/pages/admin/gestionClientes/ClientesIndexExtranjeria.vue'),
          meta: {
            breadcrumb: [
              { title: 'inicio', url: '/' },
              { title: 'Usuarios', active: false },
              { title: 'Gestión de Clientes Ext', active: true }
            ],
            pageTitle: 'Gestión de Clientes Extranjería',
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/admin/cliente/:id_client',
          name: 'admin.cliente',
          component: () => import('./views/pages/admin/gestionClientes/perfilInternoCliente/Perfil.vue'),
          meta: {
            breadcrumb: [
              { title: 'inicio', url: '/' },
              { title: 'Usuarios', active: false },
              { title: 'Gestión de Clientes', url: '/admin/clientes', active: true },
              { title: 'Perfil Interno Cliente', active: true }
            ],
            pageTitle: 'Perfil Interno Cliente',
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/admin/asesores',
          name: 'admin.asesores',
          component: () => import('./views/pages/admin/gestionAsesoresAsignados/AsignacionAsesoresIndex.vue'),
          meta: {
            breadcrumb: [
              { title: 'inicio', url: '/' },
              { title: 'Usuarios', active: false },
              { title: 'Gestión de Asesores Asignados', active: true }
            ],
            pageTitle: 'Gestión de Asesores Asignados',
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/admin/gestion-servicios',
          name: 'admin.gestion-servicios',
          component: () => import('./views/pages/admin/gestionServicios/ServicesIndex.vue'),
          meta: {
            breadcrumb: [
              { title: 'inicio', url: '/' },
              { title: 'Servicios', active: false },
              { title: 'Gestión de Servicios', active: true }
            ],
            pageTitle: 'Servicios',
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/admin/pagos',
          name: 'admin.pagos',
          component: () => import('./views/pages/admin/gestionPagos/PagosIndex.vue'),
          meta: {
            breadcrumb: [
              { title: 'inicio', url: '/' },
              { title: 'Servicios', active: false },
              { title: 'Gestión de Pagos', active: true }
            ],
            pageTitle: 'Pagos',
            requiresAuth: true,
            rule: 'admin'
          }
        },
        // {
        //   path: '/admin/mis-clientes',
        //   name: 'admin.mis-clientes',
        //   component: () => import('./views/pages/admin/MyClients.vue'),
        //   meta: {
        //     breadcrumb: [
        //       { title: 'inicio', url: '/' },
        //       { title: 'Perfil Empleado', active: true }
        //     ],
        //     pageTitle: 'Mis clientes como Gestor',
        //     requiresAuth: true,
        //     rule: 'admin'
        //   }
        // },
        {
          path: '/perfilEmpleado',
          name: 'perfilEmpleado',
          component: () => import('./views/pages/admin/perfilEmpleados/PerfilEmpleado.vue'),
          meta: {
            breadcrumb: [
              { title: 'inicio', url: '/' },
              { title: 'Perfil Empleado', active: true }
            ],
            pageTitle: 'Perfil Empleado',
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/calendario',
          name: 'calendario',
          component: () => import('./views/pages/admin/calendario/Calendario.vue'),
          meta: {
            pageTitle: 'Calendario',
            requiresAuth: true,
            rule: 'admin'
          }
        },
        {
          path: '/notificaciones',
          name: 'Notificaciones',
          component: () => import('./views/Notificaciones.vue'),
          meta: {
            requiresAuth: false,
            pageTitle: 'Tus notificaciones',
            rule: 'public'
          }
        },
        {
          path: '/tramite-nacionalidad-espanola',
          name: 'CheckNacionalidad',
          component: () => import('./views/pages/CheckNacionalidad.vue'),
          meta: {
            requiresAuth: false,
            pageTitle: 'Expediente de Nacionalidad Española',
            rule: 'public'
          }
        },
        {
          path: '/tramite-proteccion-internacional',
          name: 'CheckProteccionInternacional',
          component: () => import('./views/pages/CheckProteccionInternacional.vue'),
          meta: {
            requiresAuth: false,
            pageTitle: 'Solicitud de Protección Internacional',
            rule: 'public'
          }
        },
        {
          path: '/guia-de-barrios',
          name: 'GuiaDeBarrios',
          component: () => import('./views/pages/GuiaDeBarrios.vue'),
          meta: {
            requiresAuth: false,
            pageTitle: 'Guia De Barrios',
            rule: 'public'
          }
        },        
        //Barrios
        {
          path: '/guias-de-integracion',
          name: 'GuiasDeIntegracion',
          component: () => import('./views/pages/GuiasDeIntegracion.vue'),
          meta: {
            requiresAuth: false,
            pageTitle: 'Guias De Integracion',
            rule: 'public'
          }
        },
        {
          path: '/ofertas-laborales',
          name: 'OfertasLaborales',
          component: () => import('./views/pages/OfertasLaborales.vue'),
          meta: {
            requiresAuth: false,
            pageTitle: 'Ofertas Laborales',
            rule: 'public'
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/login',
          name: 'login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            requiresAuth: false,
            rule: 'public'
          }
        },
        {
          path: '/register',
          name: 'register',
          component: () => import('@/views/pages/Register.vue'),
          meta: {
            requiresAuth: false,
            rule: 'public'
          }
        },
        {
          path: 'forgot-password',
          name: 'forgot-password',
          component: () => import('@/views/pages/ForgotPassword.vue'),
          meta: {
            auth: false,
            requiresAuth: false,
            rule: 'public'
          }
        },
        {
          path: 'reset-password',
          name: 'reset-password',
          component: () => import('@/views/pages/ResetPassword.vue'),
          meta: {
            auth: false,
            requiresAuth: false,
            rule: 'public'
          }
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue'),
          meta: {
            requiresAuth: false,
            rule: 'public'
          }
        }
        
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('userInfo')
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/login')
  }
  next()
})

export default router
